import { assertPackageVersion } from '@dynamic-labs-sdk/assert-package-version';

import {
  name as packageName,
  version as packageVersion,
} from '../../package.json';
assertPackageVersion(packageName, packageVersion);

export { addBitcoinExtension } from '../addBitcoinExtension';
export type { BitcoinNetworkProvider } from '../BitcoinNetworkProvider.types';
export type { BitcoinWalletAccount } from '../BitcoinWalletAccount.types';
export type {
  BitcoinAddressType,
  BitcoinSendTransactionResponse,
  BitcoinSignProtocol,
  BitcoinSignPsbtRequest,
  BitcoinTransaction,
} from '../BitcoinWalletProvider.types';
export { InvalidPsbtError } from '../errors/InvalidPsbtError';
export { TransactionBroadcastFailedError } from '../errors/TransactionBroadcastFailedError';
export { TransactionRequiredError } from '../errors/TransactionRequiredError';
export { isBitcoinNetworkProvider } from '../isBitcoinNetworkProvider';
export { isBitcoinWalletAccount } from '../isBitcoinWalletAccount';
export { sendBitcoin } from '../sendBitcoin';
export { sendRawTransaction } from '../sendRawTransaction';
export { signMessageWithCustomOptions } from '../signMessageWithCustomOptions';
export { signPsbt } from '../signPsbt';
export { signPsbts } from '../signPsbts';
